import { Tooltip } from 'react-bootstrap';

const renderTooltip = (props: any, text: string) => (
  <Tooltip id="button-tooltip" {...props}>
    {text}
  </Tooltip>
);

export default renderTooltip;
